import * as THREE from 'three';

import config from './config';

import PointSystem from './PointSystem';
import PointRenderer from './PointRenderer';
import EdgeRenderer from './EdgeRenderer';

//import DistanceAlgorithm from './DistanceAlgorithm';
import DelaunayAlgorithm from './DelaunayAlgorithm';

export default class NetworkAnimation {

    constructor(containerId = 'animation-canvas') {

        this.container =
            document.getElementById(containerId);

        if (!this.container) {

            throw new Error(
                `Container "${containerId}" not found.`
            );

        }

        this.container.innerHTML = '';

        this.scene = null;
        this.camera = null;
        this.renderer = null;
        this.clock = null;

        this.pointSystem = null;
        this.pointRenderer = null;
        this.edgeRenderer = null;
        this.algorithm = null;

        this.mouse = new THREE.Vector2();

        this.running = false;

        this.animate = this.animate.bind(this);

        this.onResize = this.onResize.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);

    }

    init() {

        this.createScene();

        this.createCamera();

        this.createRenderer();

        this.createPointSystem();

        this.createRenderers();

        this.createAlgorithm();

        window.addEventListener(
            'resize',
            this.onResize
        );

        window.addEventListener(
            'mousemove',
            this.onMouseMove
        );

        this.running = true;

        this.animate();

    }

    createScene() {

        this.scene = new THREE.Scene();

    }

    createCamera() {

        this.camera =
            new THREE.PerspectiveCamera(

                config.camera.fov,

                window.innerWidth /
                window.innerHeight,

                config.camera.near,

                config.camera.far

            );

        this.camera.position.set(

            config.camera.position.x,

            config.camera.position.y,

            config.camera.position.z

        );

    }

    createRenderer() {

        this.renderer =
            new THREE.WebGLRenderer({

                alpha: true,

                antialias: true

            });

        this.renderer.setPixelRatio(
            window.devicePixelRatio
        );

        this.renderer.setSize(

            window.innerWidth,

            window.innerHeight

        );

        this.container.appendChild(

            this.renderer.domElement

        );

        this.clock = new THREE.Clock();

    }
        createPointSystem() {

        this.pointSystem = new PointSystem({

            count: config.points.count,

            width: config.points.width,

            height: config.points.height,

            depth: config.points.depth,

            speed: config.points.speed

        });

    }

    createRenderers() {

        this.pointRenderer = new PointRenderer(

            this.scene,

            this.pointSystem,

            {

                color: config.points.color,

                size: config.points.size,

                opacity: config.points.opacity

            }

        );

        this.edgeRenderer = new EdgeRenderer(

            this.scene,

            {

                color: config.edges.color,

                opacity: config.edges.opacity,

                maxEdges: config.edges.maxEdges

            }

        );

    }

    createAlgorithm() {

    this.algorithm = new DelaunayAlgorithm();

	}
	
    update(delta) {
		
		if (this.pointRenderer) {

		this.pointRenderer.material.uniforms.uTime.value += delta;

		}

        this.pointSystem.update(delta);

        const edges = this.algorithm.compute(

            this.pointSystem.getPoints()

        );

        this.edgeRenderer.update(edges);

        this.pointRenderer.update();

    }

    render() {

        this.renderer.render(

            this.scene,

            this.camera

        );

    }
    animate() {

        if (!this.running)
            return;

        requestAnimationFrame(this.animate);

        const delta = Math.min(
    this.clock.getDelta(),
    0.033
);

this.update(delta);

        if (config.mouse.enabled) {

            this.camera.position.x +=
                (
                    this.mouse.x * config.mouse.strengthX -
                    this.camera.position.x
                ) * config.mouse.smoothing;

            this.camera.position.y +=
                (
                    this.mouse.y * config.mouse.strengthY -
                    this.camera.position.y
                ) * config.mouse.smoothing;

            this.camera.lookAt(0, 0, 0);

        }

        this.render();

    }

    onResize() {

        this.camera.aspect =
            window.innerWidth /
            window.innerHeight;

        this.camera.updateProjectionMatrix();

        this.renderer.setSize(

            window.innerWidth,

            window.innerHeight

        );

    }

    onMouseMove(event) {

        this.mouse.x =
            (event.clientX / window.innerWidth - 0.5) * 2;

        this.mouse.y =
            -(event.clientY / window.innerHeight - 0.5) * 2;

    }

    dispose() {

        this.running = false;

        window.removeEventListener(
            'resize',
            this.onResize
        );

        window.removeEventListener(
            'mousemove',
            this.onMouseMove
        );

        if (this.pointRenderer)
            this.pointRenderer.dispose();

        if (this.edgeRenderer)
            this.edgeRenderer.dispose();

        if (this.renderer) {

            this.renderer.dispose();

            if (
                this.renderer.domElement &&
                this.renderer.domElement.parentNode
            ) {

                this.renderer.domElement.parentNode.removeChild(
                    this.renderer.domElement
                );

            }

        }

    }

}
